import React, { useRef, useEffect } from "react";
import { RiPlayMiniFill, RiPauseMiniLine } from "react-icons/ri";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { changeTrack, changePlayPause } from "../../actions";
function SongCard({
  data,
  link,
  changePlayPause,
  changeTrack,
  isPlaying,
  songData,
}) {
  const { title, thumbnail, singer } = data;

  const playPause = useRef();
  const mainCard = useRef();

  const showPlayPause = () => {
    playPause.current.style.opacity = 1;
    playPause.current.style.transform = "translateY(-36px)";
    mainCard.current.style.backgroundColor = "#2f2f2f";
  };
  const unShowPlayPause = () => {
    playPause.current.style.opacity = 0;
    playPause.current.style.transform = "translateY(0px)";
    mainCard.current.style.backgroundColor = "#181818";
  };

  const changeSong = () => {
    changeTrack(data._id);
  };

  return (
    <div className="relative">
      <Link to={link + data._id} key={data._id}>
        <div
          onMouseOver={showPlayPause}
          onMouseOut={
            !isPlaying && songData._id == data._id
              ? showPlayPause
              : unShowPlayPause
          }
          ref={mainCard}
          style={{
            margin: "18px 28px 18px 0",
            borderRadius: 6,
            padding: 14,
            paddingBottom: 26,
            cursor: "pointer",
          }}
          className="hover:bg-[#2f2f2f] bg-[#1f1f1f] transition-all duration-200 ease-in-out "
        >
          <div
            style={{
              width: 180,
              height: 200,
              position: "relative",
              backgroundImage: `url(${thumbnail})`,
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              borderRadius: 4,
            }}
          ></div>
          <h4
            style={{
              fontSize: 18,
              marginTop: 8,
              color: "white",
            }}
          >
            {title.substr(0, 18)}
            {title.length > 18 ? (
              <span className="text-sm opacity-50"> ...</span>
            ) : null}
          </h4>
          <p
            style={{
              fontSize: 12,
              opacity: 0.6,
              color: "white",
              maxWidth: 198,
            }}
          >
            {singer.substr(0, 18)}
            {singer.length > 18 ? (
              <span className="text-sm opacity-50"> ...</span>
            ) : null}
          </p>
        </div>
      </Link>
      <div
        onMouseOver={showPlayPause}
        onClick={changeSong}
        ref={playPause}
        style={{ boxSizing: "border-box", padding: 8 }}
        className={`rounded-full  bg-[#1fdf64] hover:bg-[#5cfb96] ${
          !isPlaying &&
          songData._id == data._id &&
          "opacity-100" &&
          "translate-y-[-36px]"
        } opacity-0 absolute right-[50px] bottom-[70px]  transition-all ease-in-out cursor-pointer flex items-center justify-center duration-300`}
      >
        {!isPlaying && songData._id == data._id ? (
          <RiPauseMiniLine
            onClick={() => changePlayPause(!isPlaying)}
            style={{
              fontSize: 30,
            }}
            className="text-black rounded-full "
          />
        ) : (
          <RiPlayMiniFill
            onClick={() => changePlayPause(!isPlaying)}
            style={{
              fontSize: 30,
            }}
            className="text-black rounded-full "
          />
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    songData: state.songData,
    isPlaying: state.isPlaying,
  };
};

export default connect(mapStateToProps, { changeTrack, changePlayPause })(
  SongCard
);
